import { AddCircleOutlineOutlined, ArrowBack, ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Button, Card, CardContent, CardHeader, Divider, Grid, IconButton, List, ListItem, ListItemText, ListSubheader, Paper, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate, useOutletContext } from 'react-router-dom';
import MyTable from '../../../../components/MyTable';
import { base_url } from '../../../../utils/GlobalVariables';
import { CustomDescrypt } from '../../../../utils/MyEncryption';
import Adendum from './adendum/Index';

const DetailKontrak = () => {
    const navigate = useNavigate();
    const { setBreadcrumbItem } = useOutletContext();
    const encryptUser = localStorage.getItem('AuthPersist');
    const encryptUserJson = JSON.parse(encryptUser);
    const decryptedUser = encryptUserJson.state.user === null ? "" : JSON.parse(CustomDescrypt(encryptUserJson.state.user));
    const location = useLocation();
    const stateKontrak = location.state || null;
    const [kontrak, setKontrak] = useState({
        no_kontrak: "",
        tgl_kontrak: "",
        no_rek_kegiatan: "",
        pekerjaan: "",
        lokasi: "",
        jumlah_anggaran_dalam_dpa: "",
        jumlah_kontrak: "",
        nomor_spk: "",
        tgl_spk: "",
        tgl_mulai: "",
        tgl_selesai: "",
        nama_perusahaan: "",
        nama_pimpinan: "",
        jabatan: "",
        alamat: "",
        nomor_rekening_bank: "",
        npwp_perusahaan: "",
        file: "",
    })
    const [pencairan, setPencairan] = useState([])

    useEffect(() => {
        setBreadcrumbItem({ '/bnd': 'Home', '/bnd/kontrak': 'Kontrak', '/bnd/kontrak/detail': 'Detail Kontrak' });

        // console.log(stateKontrak);

        if (stateKontrak !== null) {
            setKontrak({
                no_kontrak: stateKontrak.no_kontrak,
                tgl_kontrak: stateKontrak.tgl_kontrak,
                no_rek_kegiatan: stateKontrak.no_rek_kegiatan,
                pekerjaan: stateKontrak.pekerjaan,
                lokasi: stateKontrak.lokasi,
                jumlah_anggaran_dalam_dpa: stateKontrak.jumlah_anggaran_dalam_dpa,
                jumlah_kontrak: stateKontrak.jumlah_kontrak,
                nomor_spk: stateKontrak.nomor_spk,
                tgl_spk: stateKontrak.tgl_spk,
                tgl_mulai: stateKontrak.tgl_mulai,
                tgl_selesai: stateKontrak.tgl_selesai,
                nama_perusahaan: stateKontrak.nama_perusahaan,
                nama_pimpinan: stateKontrak.nama_pimpinan,
                jabatan: stateKontrak.jabatan,
                alamat: stateKontrak.alamat,
                nomor_rekening_bank: stateKontrak.nomor_rekening_bank,
                npwp_perusahaan: stateKontrak.npwp_perusahaan,
                file: base_url + '/uploads/' + decryptedUser.tahun_anggaran + '/' + decryptedUser.id_opd + '/kontrak/' + stateKontrak.file,
            });
            setPencairan(stateKontrak.pencairan);
            console.log(stateKontrak.pencairan);
        }

        // requestData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const rP = (e) => {
        const cur = new Intl.NumberFormat("id-ID", {
            maximumFractionDigits: 0,
            minimumFractionDigits: 0
        }).format(e);
        return cur;
    }

    const columns = [
        {
            field: 'updated_at',
            headerName: 'Tanggal Update',
            filterable: false,
            hide: true
        },
        {
            field: 'created_at',
            headerName: 'Tanggal Input',
            filterable: false,
            hide: true
        },
        {
            field: 'no_spm',
            headerName: 'Nomor SPM',
            minWidth: 280,
        },
        { field: 'tgl_spm', headerName: 'Tanggal SPM' },
        {
            field: 'jenis',
            headerName: 'Jenis',
            width: 80,
            renderCell: (params) => {
                return params.row.jenis + " " + params.row.jenis_ls
            }
        },
        { field: 'keperluan', headerName: 'Keperluan', width: 430 },
        {
            field: 'anggaran',
            headerName: 'Anggaran',
            width: 150,
            renderCell: (params) => {
                return new Intl.NumberFormat("id-ID", {
                    style: "currency",
                    currency: "IDR",
                    maximumFractionDigits: 0,
                    minimumFractionDigits: 0,
                }).format(params.row.anggaran);
            }
        },
        { field: 'no_spp', headerName: 'Nomor SPP', width: 100, hide: true },
    ];

    return (
        <>
            <Card>
                <CardHeader
                    title={
                        <Typography variant='h5'>Kembali</Typography>
                    }
                    avatar={
                        <Tooltip title="Kembali">
                            <IconButton variant="outlined" onClick={() => {
                                navigate("/bnd/kontrak", { replace: true })
                            }} color="error"><ArrowBack /></IconButton>
                        </Tooltip>
                    }
                // subheader="September 14, 2016"
                />
                <CardContent>
                    <Paper variant='outlined'>
                        <List subheader={
                            <ListSubheader component="div" id="utility">
                                Informasi Pekerjaan
                            </ListSubheader>
                        }
                        >
                            <ListItem alignItems="flex-start">
                                <Grid container>
                                    <Grid item md={12}>
                                        <ListItemText
                                            primary="Pekerjaan"
                                            secondary={kontrak.pekerjaan}
                                        />
                                    </Grid>
                                </Grid>
                            </ListItem>
                            <Divider />
                            <ListItem alignItems="flex-start">
                                <Grid container>
                                    <Grid item md={6}>
                                        <ListItemText
                                            primary="Nomor dan Tanggal Kontrak"
                                            secondary={kontrak.no_kontrak + " / " + kontrak.tgl_kontrak}
                                        />
                                    </Grid>
                                    <Grid item md={6}>
                                        <ListItemText
                                            primary="Nomor Rekening Kegiatan"
                                            secondary={kontrak.no_rek_kegiatan}
                                        />
                                    </Grid>
                                </Grid>
                            </ListItem>
                            <Divider />
                            <ListItem alignItems="flex-start">
                                <Grid container>
                                    <Grid item md={6}>
                                        <ListItemText
                                            primary="Jumlah Anggaran dalam DPA / DPPA"
                                            secondary={"Rp. " + rP(kontrak.jumlah_anggaran_dalam_dpa)}
                                        />
                                    </Grid>
                                    <Grid item md={6}>
                                        <ListItemText
                                            primary="Jumlah Kontrak"
                                            secondary={"Rp. " + rP(kontrak.jumlah_kontrak)}
                                        />
                                    </Grid>
                                </Grid>
                            </ListItem>
                            <Divider />
                            <ListItem alignItems="flex-start">
                                <Grid container>
                                    <Grid item md={6}>
                                        <ListItemText
                                            primary="Nomor dan Tanggal SPK"
                                            secondary={kontrak.nomor_spk + " / " + kontrak.tgl_spk}
                                        />
                                    </Grid>
                                    <Grid item md={6}>
                                        <ListItemText
                                            primary="Lokasi"
                                            secondary={kontrak.lokasi}
                                        />
                                    </Grid>
                                </Grid>
                            </ListItem>
                            <Divider />
                            <ListItem alignItems="flex-start">
                                <Grid container>
                                    <Grid item md={12}>
                                        <ListItemText
                                            primary="Jangka Waktu Pelaksanaan"
                                            secondary={kontrak.tgl_mulai + " s/d " + kontrak.tgl_selesai}
                                        />
                                    </Grid>
                                </Grid>
                            </ListItem>
                        </List>
                    </Paper>
                    <Paper variant='outlined' sx={{ mt: 2 }}>
                        <List subheader={
                            <ListSubheader component="div" id="utility">
                                Informasi Penyedia
                            </ListSubheader>
                        }
                        >
                            <ListItem alignItems="flex-start">
                                <Grid container>
                                    <Grid item md={6}>
                                        <ListItemText
                                            primary="Nama Perusahaan"
                                            secondary={kontrak.nama_perusahaan}
                                        />
                                    </Grid>
                                    <Grid item md={6}>
                                        <ListItemText
                                            primary="Alamat"
                                            secondary={kontrak.alamat}
                                        />
                                    </Grid>
                                </Grid>
                            </ListItem>
                            <Divider />
                            <ListItem alignItems="flex-start">
                                <Grid container>
                                    <Grid item md={6}>
                                        <ListItemText
                                            primary="Nama Pimpinan Perusahaan"
                                            secondary={kontrak.nama_pimpinan}
                                        />
                                    </Grid>
                                    <Grid item md={6}>
                                        <ListItemText
                                            primary="Jabatan"
                                            secondary={kontrak.jabatan}
                                        />
                                    </Grid>
                                </Grid>
                            </ListItem>
                            <Divider />
                            <ListItem alignItems="flex-start">
                                <Grid container>
                                    <Grid item md={6}>
                                        <ListItemText
                                            primary="NPWP Perusahaan"
                                            secondary={kontrak.npwp_perusahaan}
                                        />
                                    </Grid>
                                    <Grid item md={6}>
                                        <ListItemText
                                            primary="No. Rekening Bank"
                                            secondary={kontrak.nomor_rekening_bank}
                                        />
                                    </Grid>
                                </Grid>
                            </ListItem>
                        </List>
                    </Paper>
                    <Paper variant='outlined' sx={{ mt: 2 }}>
                        <Accordion>
                            <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" expandIcon={<ExpandMore />}>
                                <Typography>File Kontrak</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <iframe width='100%' height={700} title="Pdf" src={kontrak.file} />
                            </AccordionDetails>
                        </Accordion>
                    </Paper>
                    <Paper variant='outlined' sx={{ mt: 2 }}>
                        <List subheader={
                            <ListSubheader component="div" id="utility" sx={{ justifyContent: "space-between" }}>
                                <Grid container justifyContent="space-between">
                                    <Grid item>
                                        <Typography variant='subtitle2' pt={1}>Adendum</Typography>
                                    </Grid>
                                    <Grid item>
                                        <Button
                                            variant="contained"
                                            endIcon={<AddCircleOutlineOutlined color='white' />}
                                            to="/bnd/kontrak/adendum-add"
                                            component={Link}
                                            state={{ adendum: null, no_kontrak: kontrak.no_kontrak }}
                                        >
                                            Tambah
                                        </Button>
                                    </Grid>
                                </Grid>
                            </ListSubheader>
                        }>
                            <ListItem alignItems="flex-start">
                                {kontrak.no_kontrak !== "" && <Adendum noKontrak={kontrak.no_kontrak} kontrak={kontrak} />}
                            </ListItem>
                        </List>
                    </Paper>
                    <Card variant='outlined' sx={{ mt: 2 }}>
                        <CardHeader
                            title="Pencairan Dana"
                        />
                        <CardContent>
                            <MyTable
                                rows={pencairan}
                                columns={columns}
                                row_id={(row) => row.no_spm}
                            />
                        </CardContent>
                    </Card>
                </CardContent>
            </Card>
        </>
    )
}

export default DetailKontrak